import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemWithCustomProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Props as ChangedActivitiesTableProps } from 'components/widgets/ScheduleSimulation/components/ChangedActivitiesTable/ChangedActivitiesTable';

export const changedActivities: IHashmapItemWithCustomProps<ChangedActivitiesTableProps> = {
    NoPermissionMessage,
};
